import { render, staticRenderFns } from "./couponRedemptionList.vue?vue&type=template&id=01cba01e&scoped=true"
import script from "./couponRedemptionList.vue?vue&type=script&lang=js"
export * from "./couponRedemptionList.vue?vue&type=script&lang=js"
import style0 from "./couponRedemptionList.vue?vue&type=style&index=0&id=01cba01e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cba01e",
  null
  
)

export default component.exports